<template>
    <div class="contentMap">
        <div class="contentMap__map" ref="myMap"></div>
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>